import { useCallback, useEffect, useState } from "react";
import {CourseEvent} from "../../models/CourseEvent";
// import {availableCourses} from "../../dummydata/availableCourses";
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import {Calendar} from 'react-bootstrap-icons';
import { Clock } from "react-bootstrap-icons";
import { GeoAlt } from "react-bootstrap-icons";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { RegistrationModal } from "./RegistrationModal";
import { WaitlistModal } from "./WaitlistModal";
import CourseEventEndpoint from "../../../api/endpoint/CourseEventEndpoint";
import { RichTextDisplay } from '../widget/RichText';
import { sharedSearchCache } from "../../../api/SearchCache";
import { displayDateAsVtTime, displayFullDateAsVtTime, displayMonthAsVtTime, displayTimeAsVtTime } from "../../utils/DateManagement";

const dateCardStyle = {
    width: "6em",
    height: "6.5em",
    display: "inline-block",
    color: "primary",
    borderRadius: '5px'
} as const;

const dateCardTextStyle = {
    position: "relative",
    right: "17%",
    top: "15%",
    fontSize: '1em',
    fontWeight: 'bold'
} as const;

const dateIconStyle = {
    position: "relative",
    left: "23%",
    zIndex: 0
} as const;

export const AvailableCourses = () => {
    const [courses, setCourses] = useState<CourseEvent[] | undefined>(undefined);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showWaitRegistration, setShowWaitRegistration] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState<CourseEvent | undefined>(undefined);
    const [needsReload, setNeedsReload] = useState(true);

    useEffect(() => {
        if(isInitialLoad){
            getCourses();
            setIsInitialLoad(false);
        }
    }, [isInitialLoad]);

    const getCourses = async () => {
        const result = await CourseEventEndpoint.GetAvailable();
        const courseEventsResult: CourseEvent[] = result.data.map((row: any) => ({
            course_event_id: Number(row.course_event_id),
            course_id: Number(row.course_id),
            title: row.title,
            hours: row.hours,
            location: row.location,
            close_date: new Date(Date.parse(row.close_date)),
            start_date: new Date(Date.parse(row.start_date)),
            end_date: new Date(Date.parse(row.end_date)),
            open_date: new Date(Date.parse(row.open_date)),
            max_registrations: Number(row.max_registrations),
            current_registrations: Number(row.current_registrations),
            description: row.description,
            location_details: row.location_details,
            waitlist: Number(row.waitlist)
        }));
        setCourses(courseEventsResult);
    };
    
    useEffect(() => {
        if(needsReload) {
            getCourses();
            setNeedsReload(false);
        }
    }, [needsReload]);

    const handleRegistrationClose = () => {
        setShowRegistration(false);
        setSelectedCourse(undefined);
    };

    const initiateReload = useCallback(() => {
        sharedSearchCache.clear();
        setTimeout(() => {
            setNeedsReload(true);
        }, 1);
    }, [setNeedsReload]);

    const getEndTime = (course: CourseEvent) => {
        const endTime = new Date(course.start_date);
        endTime.setHours(endTime.getHours() + (course.hours / 2));
        return endTime;
    }

    return (
        <>
            {selectedCourse && 
                <RegistrationModal show={showRegistration} onHide={handleRegistrationClose} course={selectedCourse} initiateReload={initiateReload}/>
            }

            {selectedCourse &&
                <WaitlistModal show={showWaitRegistration} onHide={() => setShowWaitRegistration(false)} course={selectedCourse} initiateReload={initiateReload}/>
            }
            
            <h1 className="text-light">Available Courses</h1>
            <hr className="border"/>
            {courses && courses.length !== 0 && courses.map((course:CourseEvent, i: number) => {
                return(
                    
                    <Card style={{margin:"1em 0"}} key={`course_${i}`}>
                        <Card.Body>
                            <Container fluid>
                                <Row>
                                    <Col md={2} style={{borderRight:"2px solid #e6e8e9"}}>
                                        <Row className="justify-content-evenly flex-fill" >
                                            
                                            
                                            {/* First class date */}
                                            <div className="text-primary" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.start_date)}
                                                </div>
                                            
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.start_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>First<br/>Session</div>
                                            </div>

                                            {/* Last class date */}
                                            <div className="text-primary" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.end_date)}
                                                </div>
                                                
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.end_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>Last<br/>Session</div>
                                            </div>

                                            {/* Registration close date */}
                                            <div className="text-danger" style={dateCardStyle}>
                                                <div className="text-center" style={{fontVariant:"small-caps", fontWeight:"bold"}}>
                                                    {displayMonthAsVtTime(course.close_date)}
                                                </div>
                                        
                                                <div>
                                                    <Calendar size={"2.5em"} style={dateIconStyle}></Calendar>
                                                    <span style={dateCardTextStyle}>{displayDateAsVtTime(course.close_date)}</span>
                                                </div>
                                                <div className="text-center" style={{fontSize:"0.75em", fontVariant:"small-caps"}}>Registration Closes</div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col md={6} style={{paddingLeft:"2em"}}>
                                        <Card.Title>{course.title}</Card.Title>
                                        <Card.Subtitle className="text-muted">
                                            <div className="d-flex justify-content-start pb-2">
                                                <div className="pe-3">{course.location}</div>
                                                <div className="pe-3">&bull;</div>
                                                <div className="pe-3">{course.hours} hours</div>
                                                <div className="pe-3">&bull;</div>
                                                {course.max_registrations - course.current_registrations > 0 &&
                                                    <div className="pe-3">
                                                        <>{course.max_registrations - course.current_registrations} openings remaining</>
                                                    </div>
                                                }
                                                {course.max_registrations - course.current_registrations <= 0 &&
                                                    <>
                                                        <div className="pe-3">
                                                            0 openings remaining
                                                        </div>
                                                        <div className="pe-3">&bull;</div>
                                                        <div className="pe-3">
                                                            Waitlist Length: {course.waitlist}
                                                        </div>
                                                    </>
                                                }
                                            </div> 
                                        </Card.Subtitle>
                                            <Accordion>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>Course Description</Accordion.Header>
                                                    <Accordion.Body className="readonly-description">
                                                        <RichTextDisplay value={course.description} />
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                            {course.current_registrations >= course.max_registrations &&
                                                <Button 
                                                    className="my-3 text-light" 
                                                    variant="primary" 
                                                    onClick={() => {
                                                        setShowWaitRegistration(true);
                                                        setSelectedCourse(course);
                                                    }}
                                                >
                                                    Join Waitlist
                                                </Button>
                                            }
                                            {course.current_registrations < course.max_registrations &&
                                                <Button 
                                                    className="my-3 text-light" 
                                                    variant="primary" 
                                                    onClick={() => {
                                                        setShowRegistration(true);
                                                        setSelectedCourse(course);
                                                    }}
                                                >
                                                        Register
                                                </Button>
                                            }
                                    </Col>
                                    <Col md={4}>
                                        
                                        <div><b>{displayFullDateAsVtTime(course.start_date)}</b></div>
                                        <div style={{paddingBottom:'1em'}}><Clock/> {displayTimeAsVtTime(course.start_date)} - {displayTimeAsVtTime(getEndTime(course))}</div>
                                        <div><b>{displayFullDateAsVtTime(course.end_date)}</b></div>
                                        <div style={{paddingBottom:'1em'}}><Clock/> {displayTimeAsVtTime(course.end_date)} - {displayTimeAsVtTime(getEndTime(course))}</div>
                                        <div style={{paddingBottom:'1em'}}><GeoAlt/> {course.location_details === '' || !course.location_details ? 'No location details provided' : course.location_details}</div>
                                    </Col>
                                </Row>
                                
                        </Container>
                        </Card.Body>
                    </Card>
                );
            })}
            {!courses || courses.length == 0 &&
                <div className="text-light">No courses available.</div>
            }
        </>
    );
};